module.exports = __webpack_public_path__ + "assets/no-diagnosis-screen-icon.108fb69c.svg";